import React from "react";
import CustomerTable from "./customer-table";


const Customer = ({data}: any) => {
  return (
    <div>
      <CustomerTable data={data} />
    </div>
  );
};

export default Customer;
